module.exports = __webpack_public_path__ + "createNew.svg?643fb98693cab537bb6bbc950668e7b4";